import Artyom from 'artyom.js/build/artyom';
import {
  skipExercise,
  previousExercise,
  pauseWorkout,
  playWorkout,
  endWorkout,
} from './workout-player';
import { playMusic, pauseMusic, skipMusic, initMusic } from './music-player';
import { swApi } from '../global/app';

export const initVoiceCommands = () => async (dispatch, _getState) => {
  const {
    localSettings: { voiceCommandsEnabled },
  } = _getState() as SworkitState;
  if (!voiceCommandsEnabled || swApi.env !== 'beta') return;
  if (
    !window ||
    (!window['webkitSpeechRecognition'] && !window['SpeechRecognition'])
  )
    return;
  const artyom = new Artyom();
  window['artyom'] = artyom;
  artyom.initialize({
    continuous: true,
    lang: 'en-US',
    listen: true,
    debug: true,
  });
  const commands = [
    {
      indexes: ['play music', 'play song'],
      action: async () => {
        await dispatch(initMusic());
        return dispatch(playMusic());
      },
    },
    {
      indexes: ['pause music', 'stop music'],
      action: () => dispatch(pauseMusic()),
    },
    {
      indexes: [
        'skip music',
        'next music',
        'skip song',
        'skip this song',
        'next song',
      ],
      action: () => dispatch(skipMusic()),
    },
    {
      indexes: ['skip', 'next'],
      action: () => dispatch(skipExercise()),
    },
    {
      indexes: ['previous', 'back', 'go back'],
      action: () => dispatch(previousExercise()),
    },
    {
      indexes: [
        'pause',
        'wait',
        'weight',
        'break',
        'stop',
        'hold on',
        'pause exercise',
        'rest',
      ],
      action: () => dispatch(pauseWorkout()),
    },
    {
      indexes: ['play', 'resume', 'start', 'continue', 'keep going', 'ready'],
      action: () => dispatch(playWorkout()),
    },
    {
      indexes: ['stop workout', 'quit', 'end workout'],
      action: () => dispatch(endWorkout()),
    },
  ];
  artyom.addCommands(commands);
};

export const stopVoiceCommands = () => async (_dispatch, _getState) => {
  if (!window['artyom'] || !window['artyom'].fatality) return;
  window['artyom'].fatality();
};
